import createSagaMiddleware, {Saga} from 'redux-saga';
import {licenseSaga} from './license/sagas';
import {modalDialogsSaga} from 'features/layout/redux/sagas';
import {commonPageSagas} from 'features/layout/CommonPage/redux/sagas';
import {settingsSaga} from './settings/sagas';
import {keysSaga} from 'redux/keys/sagas';
import {partnersSaga} from './partners/sagas';
import {transactionsSaga} from './transactions/sagas';
import {backupSagas} from './backuprestore/sagas';
import {loginSagas} from 'features/login/redux/sagas';

import {licenseKey} from './license/types';
import {commonPageKey} from 'features/layout/CommonPage/redux/types';
import {settingsReducerKey} from './settings/types';
import {keysKey} from './keys/types';
import {partnersReducerKey} from './partners/types';
import {transactionsReducerKey} from './transactions/types';
import {backupKey} from './backuprestore/types';
import {loginReducerKey} from 'features/login/redux/types';
import {LOG_ROWS_TO_DOWNLOAD} from 'common/constants';
import safeStringify from 'safe-stringify';
import {downloadTextFile} from 'common/downloadFile';

export const sagaMiddleware = createSagaMiddleware({
   onError(error, errorInfo) {
      console.error('SAGA Error ', error, errorInfo);
      const logs = console.logs.slice(-LOG_ROWS_TO_DOWNLOAD);
      const logsText = safeStringify(logs);
      downloadTextFile(logsText, `${Date.now()}_coviant-diplomat-saga-crash-report.log`);
      alert('Something went wrong. Please reload the page. Crash report downloaded.');
   },
});

// runSaga is middleware.run function
// rootSaga is a your root saga for static saagas
export function createSagaInjector(runSaga: typeof sagaMiddleware.run) {
   // Create a dictionary to keep track of injected sagas
   const injectedSagas = new Map();

   const isInjected = (key: string) => injectedSagas.has(key);

   const injectSaga = (key: string, saga: Saga<any[]>) => {
      // We won't run saga if it is already injected
      if (isInjected(key)) return;

      // Sagas return task when they executed, which can be used
      // to cancel them
      const task = runSaga(saga);

      // Save the task if we want to cancel it in the future
      injectedSagas.set(key, task);
   };

   // Inject the root saga as it a staticlly loaded file,
   // injectSaga('root', rootSaga);
   // injectSaga('states', updateStatesSaga);
   injectSaga(licenseKey, licenseSaga);
   injectSaga('modalDialogKey', modalDialogsSaga);
   injectSaga(commonPageKey, commonPageSagas);
   injectSaga(settingsReducerKey, settingsSaga);
   injectSaga(keysKey, keysSaga);
   injectSaga(partnersReducerKey, partnersSaga);
   injectSaga(transactionsReducerKey, transactionsSaga);
   injectSaga(backupKey, backupSagas);
   injectSaga(loginReducerKey, loginSagas);

   return injectSaga;
}

// export const runSagas = () => {
//    try {
//       sagaMiddleware.run(licenseSaga);
//       // sagaMiddleware.run(updateStatesSaga);
//       sagaMiddleware.run(modalDialogsSaga);
//       sagaMiddleware.run(commonPageSagas);
//       sagaMiddleware.run(settingsSaga);
//       sagaMiddleware.run(keysSaga);
//       sagaMiddleware.run(partnersSaga);
//       sagaMiddleware.run(transactionsSaga);
//       sagaMiddleware.run(backupSagas);
//       sagaMiddleware.run(loginSagas);
//    } catch (e) {
//       console.error('Unhandled saga error', e);
//    }
// };
